import { render, staticRenderFns } from "./SmsChat.vue?vue&type=template&id=652c685f&"
import script from "./SmsChat.vue?vue&type=script&lang=js&"
export * from "./SmsChat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports